/** Questions that make the intro continuation bridge render. Schema 3 owns the list. */

export interface IntroBridgeQuestion {
  text: string;
  angleType?: string;
  role?: string;
}

export function introContinuationQuestions(result: {
  schemaVersion?: string;
  continuationQuestions?: IntroBridgeQuestion[];
  starterQuestions?: string[];
} | null | undefined): IntroBridgeQuestion[] {
  if (!result || typeof result !== 'object') return [];
  if (result.schemaVersion === '3.0.0' && Array.isArray(result.continuationQuestions)) {
    return result.continuationQuestions.filter(item => item && typeof item.text === 'string' && item.text.trim());
  }
  if (Array.isArray(result.starterQuestions)) {
    return result.starterQuestions
      .filter((text): text is string => typeof text === 'string' && Boolean(text.trim()))
      .map(text => ({ text }));
  }
  return [];
}

export function introBridgeParts(result: Parameters<typeof introContinuationQuestions>[0]): {
  primary: IntroBridgeQuestion | null;
  secondary: IntroBridgeQuestion[];
  impression: boolean;
  clicks: Array<'primary' | 'secondary'>;
} {
  const questions = introContinuationQuestions(result);
  return {
    primary: questions[0] ?? null,
    secondary: questions.slice(1, 3),
    impression: Boolean(questions[0]),
    clicks: questions.slice(0, 3).map((_item, index) => (index === 0 ? 'primary' : 'secondary')),
  };
}
